jQuery(function($) {
    $(document).ready(function() {
        $.fn.setCursorPosition = function(pos) {
        if ($(this).get(0).setSelectionRange) {
            $(this).get(0).setSelectionRange(pos, pos);
        } else if ($(this).get(0).createTextRange) {
            var range = $(this).get(0).createTextRange();
            range.collapse(true);
            range.moveEnd('character', pos);
            range.moveStart('character', pos);
            range.select();
        }
        };
        $("#billing_phone").click(function(){
            $(this).setCursorPosition(4);
        }).mask("+7 (999) 999-9999");
        $(function(){
            $("#burger").click(function() {
                $("#burger").toggleClass("active");
            });
        });
    $("#billing_phone").click(function(){
                    $(this).setCursorPosition(4);
                }).mask("+7 (999) 999-9999");
            }, 100);
        });

        if($('.splide').length){
            var splide = new Splide( '.splide',{
                type: 'loop',
                speed: 1200,
                pagination: false,
                autoplay: true,
                interval: 5000,
                arrowPath: 'M 12.527344 37.613281 C 12.277344 37.859375 11.96875 37.984375 11.628906 37.984375 C 11.285156 37.984375 10.976562 37.859375 10.730469 37.613281 C 10.234375 37.117188 10.234375 36.308594 10.730469 35.8125 L 26.542969 20 L 10.730469 4.1875 C 10.234375 3.691406 10.234375 2.882812 10.730469 2.386719 C 11.226562 1.890625 12.03125 1.890625 12.527344 2.386719 L 29.242188 19.101562 C 29.738281 19.597656 29.738281 20.402344 29.242188 20.898438 Z M 12.527344 37.613281',
                breakpoints: {
                    992: {
                        pagination: true,
                        arrows: false
                    }
                }
            } );
            splide.mount();
        }

    });
});
